import type { WritableComputedRef } from "vue";

export function useUrlSort<T extends string>(
  key: string,
  defaultValue: T,
  allowed: readonly T[]
): WritableComputedRef<T> {
  const route = useRoute();
  const router = useRouter();

  return computed<T>({
    get: () => {
      const raw = route.query[key];
      const v = typeof raw === "string" ? raw : undefined;
      return v && (allowed as readonly string[]).includes(v) ? (v as T) : defaultValue;
    },
    set: (next) => {
      const query = { ...route.query };
      if (next === defaultValue) delete query[key];
      else query[key] = next;
      router.replace({ query });
    },
  });
}
